export const POIS_ON_ROUTE_TYPES = {
  category: 'category',
  application: 'application',
  subcategory: 'subcategory',
  rubric: 'rubric'
}
